export default __webpack_public_path__ + "static/recordsale-93d9cb2607f72a0162d110ea42c1125f.svg";